import { seededRandomCoordsFromCenter } from "./coords";

export type PublicLocationKind = "EXACT" | "APPROXIMATE" | "AREA";

/** A listing is approximate only when the broker saved a real street. */
export function publicLocationKind(input: {
  visibility?: "EXACT" | "APPROXIMATE" | "AREA" | null;
  streetAddress1?: string | null;
}): PublicLocationKind {
  if (input.visibility === "EXACT") return "EXACT";
  if (input.visibility === "APPROXIMATE" && input.streetAddress1?.trim()) {
    return "APPROXIMATE";
  }
  return "AREA";
}

export function roundPublicCoord(value: number | null | undefined): number | null {
  if (value == null || !Number.isFinite(value)) return null;
  return Math.round(value * 100) / 100;
}

/**
 * Public center for an area-only listing. The stored pin is not used when the
 * place has a center, so a researched street cannot place the public marker.
 */
export function areaPublicCenter(input: {
  centerLat?: number | null;
  centerLng?: number | null;
  latitude?: number | null;
  longitude?: number | null;
}): { latitude: number | null; longitude: number | null } {
  if (
    input.centerLat != null &&
    input.centerLng != null &&
    Number.isFinite(input.centerLat) &&
    Number.isFinite(input.centerLng)
  ) {
    return { latitude: input.centerLat, longitude: input.centerLng };
  }

  return {
    latitude: roundPublicCoord(input.latitude),
    longitude: roundPublicCoord(input.longitude),
  };
}

export function jitteredPublicCoords(input: {
  id: number;
  createdAt: Date;
  visibility: "EXACT" | "APPROXIMATE" | "AREA";
  latitude: number | null;
  longitude: number | null;
  centerLat?: number | null;
  centerLng?: number | null;
}): { latitude: number | null; longitude: number | null } {
  if (input.visibility === "EXACT") {
    return { latitude: input.latitude, longitude: input.longitude };
  }

  const center =
    input.visibility === "AREA"
      ? areaPublicCenter(input)
      : { latitude: input.latitude, longitude: input.longitude };

  return seededRandomCoordsFromCenter(
    `${input.id}-${input.createdAt.getTime()}`,
    center,
    input.visibility === "APPROXIMATE" ? 1000 : 4000,
  );
}
